import React, {forwardRef} from 'react';

const PreOrderSvg = forwardRef((props, ref) => (
  <svg
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <path
      d="M10.3333 11.5335V9.66683H9.66667V11.8002L11.1 13.2335L11.5667 12.7668L10.3333 11.5335ZM6 1.66683L2.05 3.95016L6 6.2335L9.95 3.95016L6 1.66683ZM0 9.65016V4.35016C0 4.10572 0.0583333 3.8835 0.175 3.6835C0.291667 3.4835 0.455555 3.32239 0.666667 3.20016L5.33333 0.516829C5.44444 0.461274 5.55278 0.416829 5.65833 0.383496C5.76389 0.350163 5.87778 0.333496 6 0.333496C6.12222 0.333496 6.23889 0.350163 6.35 0.383496C6.46111 0.416829 6.56667 0.461274 6.66667 0.516829L11.3333 3.20016C11.5444 3.32239 11.7083 3.4835 11.825 3.6835C11.9417 3.8835 12 4.10572 12 4.35016V7.00016H10.6667V5.06683L5.98333 7.76683L1.33333 5.06683V9.6335L5.33333 11.9502V13.4835L0.666667 10.8002C0.455555 10.6779 0.291667 10.5168 0.175 10.3168C0.0583333 10.1168 0 9.89461 0 9.65016ZM10 15.0002C9.07778 15.0002 8.29167 14.6752 7.64167 14.0252C6.99167 13.3752 6.66667 12.5891 6.66667 11.6668C6.66667 10.7446 6.99167 9.9585 7.64167 9.3085C8.29167 8.6585 9.07778 8.3335 10 8.3335C10.9222 8.3335 11.7083 8.6585 12.3583 9.3085C13.0083 9.9585 13.3333 10.7446 13.3333 11.6668C13.3333 12.5891 13.0083 13.3752 12.3583 14.0252C11.7083 14.6752 10.9222 15.0002 10 15.0002Z"
      fill="#6218F7"
    />
  </svg>
));

export default PreOrderSvg;
